import React, { Component } from 'react';
import { withStyles } from "@material-ui/styles";
import styles from "./styles";

class NotificationsForm extends Component {
    state = {  }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.settings}>
                This is the Notifications Settings. Feature coming soon!
            </div>
        );
    }
}

export default withStyles(styles)(NotificationsForm);